export default {
  path: '/register',
  name: 'Register',
  hidden: true,
  meta: {
    title: '注册'
  },
  component: () => import('@/views/login/Register.vue')
}
